import React from 'react';
import { Text, Line, Box, Button, space, Header, breakpoints } from '@generationtux/component-library';
import ListItem from './ListItem';
import { listCategories } from '../../../data/listCategories';
import { getProductByCatalogNumber, scrollTop } from '../../../utils/utils';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';

const SaveBox = styled(Box)`
  position: sticky;
  z-index: 1000;
  grid-template-columns: auto 1fr;
  grid-column-gap: ${space[1]}px;
  bottom: ${space[4]}px;
  @media (min-width: ${breakpoints['xl']}) {
    bottom: 2vh;
  }
`;

const List = ({ selectedCatalogNumbers, setActiveCollection, docBrownsTimeMachine, storeLook, editId }) => {
  const { push } = useHistory();
  const animationProps = useSpring({ opacity: 1, from: { opacity: 0 } });
  return (
    <animated.div style={animationProps}>
      <Box display="flex" flexFlow="column" justifyContent="center" pb={4} style={{ flexGrow: 1 }}>
        <Line my={4} />
        <Box>
          {listCategories.map(category => {
            // need to check for active product per category and populate
            const match = selectedCatalogNumbers
              .filter(selectedItem => selectedItem.name === category.name)
              .map(selectedItem => selectedItem.activeItem)[0];

            return (
              <ListItem
                key={category.name}
                category={category}
                product={getProductByCatalogNumber(match)}
                selectedCatalogNumbers={selectedCatalogNumbers}
                setActiveCollection={() => setActiveCollection(category.name)}
                docBrownsTimeMachine={docBrownsTimeMachine}
              />
            );
          })}
        </Box>

        <Line my={4} />
        <Box mb={4} pl={[4, 4, 4, 5, 5, 5]} pr={4} display="flex" justifyContent="space-between">
          <Header type={5} ml={2}>
            Total
          </Header>
          <Text display="inline" as="span" textColor="grayDarker" mr={3}>
            $
            {selectedCatalogNumbers.reduce((acc, val, index) => {
              if (!val.activeItem) {
                return acc;
              }
              const product = getProductByCatalogNumber(val.activeItem);
              if (product.type !== 'Pants') {
                acc = acc + product.costToCustomer;
              }
              return acc;
            }, 0)}
          </Text>
        </Box>

        <SaveBox display="grid" backgroundColor="white" shadowLevel={3} p={1}>
          <Button
            py={[3, 3, 3, 3, 4, 4]}
            px={[3, 3, 4, 4, 4, 4]}
            outline
            buttonType="default"
            onClick={() => push('/looks')}
          >
            Cancel
          </Button>
          <Button
            py={[3, 3, 3, 3, 4, 4]}
            px={0}
            buttonType="info"
            onClick={() => {
              scrollTop();
              storeLook(selectedCatalogNumbers, editId);
              push('/looks');
            }}
          >
            Save Look
          </Button>
        </SaveBox>
      </Box>
    </animated.div>
  );
};

export default List;
